import React from "react";
import { Alert } from "react-bootstrap";

export default function AlertSnackbar({
  isAlertShown,
  alertMessage,
  alertType = "success",
  setShow,
}) {
  return (
    <div className="alert-message">
      <Alert variant={alertType} onClose={() => setShow(false)} dismissible>
        <p style={{ margin: 0 }}>{alertMessage}</p>
      </Alert>
    </div>
  );
}
